import { Box, Tab } from "@mui/material";
import React, { useState } from "react";
import "./userdetailstab.scss";
import TestModule from "./testModule/TestModule";
import HistoryTab from "./history/HistoryTab";

const UserDetailsTab = () => {
  const [value, setValue] = useState(0);
  const navTab = ["Test Modules", "History"];

  const tabHandler = (newValue) => {
    setValue(newValue);
  };
  return (
    <Box className="nav-tab-box-wrapper">
      <Box className="nav-tab-menu-box">
        <div className="nav-tab-item-wrap">
          {navTab.map((item, index) => {
            return (
              <Tab
                label={item}
                key={index}
                variant="fullWidth"
                onClick={() => tabHandler(index)}
                className={`nav-tab-menu-item + ${value === index && `selected`}`}
              />
            );
          })}
        </div>
      </Box>
      {value === 0 && (
        <div value="1" className="info-block">
          <TestModule />
        </div>
      )}
      {value === 1 && (
        <div value="2" className="info-block">
          <HistoryTab />
        </div>
      )}
    </Box>
  );
};

export default UserDetailsTab;
